<div class="ngx-toastr toast-error" toast-component="" style="opacity: 1;" data-cy="toast-message-div">
  <button aria-label="Close" class="toast-close-button ng-tns-c17-9 ng-star-inserted" (click)="closeToast()"><span
      aria-hidden="true" class="ng-tns-c17-9">×</span></button>
  <div role="alertdialog" aria-live="polite" class="ng-tns-c17-9 toast-message ng-star-inserted"
    [class]="options.messageClass"> {{ message }} For further assistance, please contact support <a
      (click)="openSupportDialog()">here</a>.
  </div>
</div>